module.exports = __webpack_public_path__ + "img/312.60c05487.jpg";